import { getCurrentInstance, computed, shallowReactive, reactive } from 'vue';
import { ModuleBudgetSource } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetSourceComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const budgetSourceCombo = computed(() => {
    const budgetSources = store.getters[`${ModuleBudgetSource}/items`];
    return budgetSources.filter(x => !x.inactive && !x.is_parent).sortObject('budget_source_code');
  });

  // config columns combo
  const cacheBudgetSourceComboConfig = reactive({
    data: budgetSourceCombo,
    columns: [
      {
        title: 'Mã nguồn',
        dataField: 'budget_source_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nguồn',
        dataField: 'budget_source_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_source_name',
    valueField: 'budget_source_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_source_id',
      titleSearch: 'Tìm nhanh nguồn',
    },
  });
  return { cacheBudgetSourceComboConfig };
};
